import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
`

export const List = styled.div`
    padding: 0 8px;
    width: 100%;
`

export const ListItem = styled.div`
    width: 100%;
    border-bottom: 1px solid var(--color-gray-200);
    padding-bottom: 4px;
    margin-bottom: 8px;
    &:last-child {
        border-bottom: none;
    }
`

export const Header = styled.div`
    display: flex;
    align-items: center;
    height: 22px;
    gap: 8px;
    /* padding-top: 4px; */
    /* margin-top: 8px; */
`

export const Label = styled.div`
    font-size: 14px;
    color: var(--color-gray-700);
    font-weight: 400;
    height: 22px;
    line-height: 22px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`

export const Type = styled.div`
    color: var(--color-gray-400);
    font-size: 12px;
    font-weight: 400;
    height: 20px;
    line-height: 20px;
    white-space: nowrap;
`

export const Desc = styled.div`
    color: var(--color-gray-500);
    font-size: 12px;
    font-weight: 400;
    white-space: pre-wrap;
    line-height: 20px;
    margin-top: 4px;
    margin-bottom: 4px;
`
